import { AlertTriangle } from 'lucide-react'

import accelerateIcon from '../../../../assets/accelerateIcon.png'

export default function AccelerateOption({ selectingRefundOption, handleSelectRefundOption }) {
  return (
    <div className='h-full flex flex-col items-center shadow-md bg-gray-50 flex-1'>
      <div className='flex flex-col items-center bg-gray-100 w-full p-4'>
        <img src={accelerateIcon} alt='Accelerate Icon' />
        <p className='font-bold text-xl'>Acceleration Program</p>
        <p className='font-bold'>90% of principle - 120 days or less</p>
      </div>
      <div className='w-full flex flex-col gap-6 p-4 h-full bg-ertc-secondary'>
        <div className='bg-white p-4'>
          <p className='font-bold'>ERC Accelerator Program</p>
          <p>Get 90% of your ERC claim in 120 days or less - with no upfront cost.</p>
          <ul className='list-disc ml-5 mt-2'>
            <li>No payment upfront</li>
            <li>We only get paid when you get paid</li>
            <li>If it takes longer than 120 days, you only pay a $100 processing fee</li>
          </ul>
          <p className='flex flex-row items-start gap-2'><AlertTriangle className='w-5 h-5 shrink-0 text-yellow-500' /> An estimated 1 in 3 ERC claims are currently stalled due to the moratorium - the Accelerator can help unlock your refund faster with direct support.</p>
        </div>
        <button
          disabled={selectingRefundOption}
          className='w-full mt-auto rounded-lg p-2 transition duration-200 text-white bg-ertc-primary disabled:bg-gray-400 disabled:cursor-not-allowed'
          onClick={() => handleSelectRefundOption(true)}
        >
          Choose Acceleration Program
        </button>
      </div>
    </div>
  )
}